import {stateData, reduxState} from '../../values';

export const getApps = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_apps,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateApps = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_apps,
            payload:    data,
        })
    }
}